<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
    <div class="card-header pb-0">
      <h6>Lista de Modelos</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">

        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ref</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Stock</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Bodega</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Costo de modelo</th>
            </tr>
          </thead>
          <tbody>
            <tr  v-for="value in data" :key="value.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ value?.model?.name }}</h6>
                    <p class="text-xs text-secondary mb-0">{{ value?.model?.description }}</p>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ value?.model?.ref }}</h6>
                  </div>
                </div>
              </td>
              <td>
                <div class="px-2 py-1">
                  <div class="justify-content-center text-center">
                    <h6 class="mb-0 text-sm text-center">{{ value.total_quantity }}</h6>
                  </div>
                </div>
              </td>
              <td>
                <div class="px-2 py-1">
                  <div class="justify-content-center text-center">
                    <h6 class="mb-0 text-sm text-center">{{ value?.bodega?.name??"Sin asignar" }}</h6>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                {{ parseFloat(value?.model?.price).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
              </td>
             
            </tr>
           
            <tr v-if="data.length === 0">
              <td colspan="5" class="text-center text-xxs">No hay registros disponibles</td>
            </tr>
          </tbody>
        </table>
    
      

        <div class="pagination p-3">
          <!-- Recorremos los links para generar los botones -->
          <a 
            v-for="link in links" 
            :key="link.label" 
            class="page-item cursor-pointer" 
            @click="fetchData(link.url)" 
            :disabled="!link.url || link.active" 
            :class="{ 'active': link.label === currentPage.toString() }"
          >
            {{ link.label }}
          </a>
        </div>

      </div>

    
    </div>
  </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProjectsList',
  computed: {
    ...mapGetters('productionModels', ['allData','currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
        return this.$store.state.productionModels.currentPage; // Obtiene la página actual
    },
    lastPage() {
        return this.$store.state.productionModels.lastPage; // Obtiene la última página
    },
    data() {
        return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['productionModels/links']; // Retorna los links
    },
  },
  methods: {
    async fetchData(pageUrl = null) {
      await this.$store.dispatch('productionModels/fetchData',pageUrl); 
    },

  },
  mounted() {
    this.fetchData(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page-item {
  margin: 0 5px;
}
.active {
  font-weight: bold; /* Estilo para la página activa */
}
</style>